module.exports = __webpack_public_path__ + "media/images/vector_plus_with_1_dot-570674644a86172670c88281f018c150.svg";